import React from 'react'
import moment from 'moment'
import { Button } from 'components'
import { Permissions } from './Permissions'

export const notifications = [
    { value: 'customerSupportTickets', label: 'Customer support tickets' },
    { value: 'pendingOrders', label: 'Pending orders' },
    { value: 'invoices', label: 'Invoices' },
]

export const columnsData = ({ updateManager, loadingUpdateManager, updateRole, loadingUpdateRole, updatedPermissions, isManager }) => {
    const columns = [
        {
            Header: 'Email',
            accessor: 'email',
            width: 250,
        },
        {
            Header: 'Invite sent',
            accessor: 'createdAt',
            Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
            width: 75,
        },
        {
            Header: 'Permission to view',
            id: 'accessToPages',
            accessor: row => ({ accessToPages: row.accessToPages, email: row.email }),
            Cell: ({ value }) => (
                <Permissions
                    value={value}
                    updateRole={updateRole}
                    loadingUpdateRole={loadingUpdateRole}
                    keyValue="accessToPages"
                    isManager={isManager}
                    {...{ updatedPermissions }}
                />
            ),
        },
        {
            Header: 'Email notifications',
            accessor: row => ({ emailNotifications: row.emailNotifications, email: row.email }),
            id: 'emailNotifications',
            Cell: ({ value }) => (
                <Permissions
                    value={value}
                    updateRole={updateRole}
                    loadingUpdateRole={loadingUpdateRole}
                    keyValue="emailNotifications"
                    isManager={isManager}
                    {...{ updatedPermissions }}
                />
            ),
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ value }) => <p className={`settingsManagerStatus settingsManagerStatus--${value}`}>{value}</p>,
            width: 90,
        },
    ]

    const disableManagerCoumn = {
        Header: '',
        accessor: row => ({
            supplierAdminId: row.supplierAdminId,
            status: row.status,
            email: row.email,
        }),
        id: 'delete',
        Cell: ({ value }) =>
            value.supplierAdminId &&
            value.status !== 'Pending' && (
                <Button
                    size="small"
                    loading={loadingUpdateManager === value.supplierAdminId}
                    onClick={() =>
                        updateManager({
                            supplierAdminId: value.supplierAdminId,
                            state: value.status === 'Complete' ? 'disable' : 'enable',
                            email: value.email,
                        })
                    }
                >
                    {value.status === 'Complete' ? 'Disable' : 'Enable'}
                </Button>
            ),
        width: 70,
    }

    if (!isManager) columns.push(disableManagerCoumn)

    return columns
}
